
import { retornoHashValor } from '../../modulos/cripotografia/hash';
import apiZelo from '../backAxiosVendaToken';

const url = retornoHashValor(process.env.REACT_APP_1);
const token = localStorage.getItem('token');
let retorno;

export const BuscarAssoc = async cod => {
    try {
        const response = await apiZelo.get(
            `/Associados/${cod}`
        );

        return response.data;
    } catch (error) {
        return error.message;
    }
};

export const UpdateAssoc = async (inscricao, dadosAssoc) => {
    try {
        const response = await apiZelo.put(
            `/Associados/${inscricao}`,
            dadosAssoc
        );

        return response;
    } catch (err) {
        return err.message;
    }
};

export const AtualizarStatus = async (inscricao, status) => {
    try {
        const response = await apiZelo.patch(
            `/associados-status/${inscricao}/${status}`
        );

        return response;
    } catch (error) {
        return error.message;
    }
};

export const BuscarAreaDeAtuacao = async (cod, tipo) => {
    try {
        const response = await apiZelo.get(`/area-de-atuacao/${cod}/${tipo}`);

        if (response.data.length > 0) {
            return response.data;
        } else {
            return { erro: 'parametros errados' };
        }
    } catch (error) {
        return { erro: error.message };
    }
};

export const BuscarInfosPerfil = async perfil => {
    try {
        const response = await apiZelo(`/${perfil}`);

        return response;
    } catch (error) {
        return error;
    }
};

export const EnviarEmail = async value => {
    await fetch(`${url}/enviarEmail/pdf-resource/inscricao/comprovante`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'x-auth-token': token
        },
        body: JSON.stringify(value)
    })
        .then(resp => {
            retorno = resp;
        })
        .catch(err => {
            retorno = console.error('Parametros errados!', err);
        });

    return retorno;
};

export const SalvarValorDinamicoAssoc = async dadosAssoc => {
    try {
        const response = await apiZelo.post(
            'associados/valor/dinamico',
            dadosAssoc
        );

        return response;
    } catch (err) {
        return err.message;
    }
};

export const EditarValorDinamicoAssoc = async (inscricao, valor) => {
    try {
        const response = await apiZelo.patch(
            `associados/valor/dinamico/${inscricao}`,
            valor
        );

        return response;
    } catch (err) {
        return err.message;
    }
};
